/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The capacity in which the company representative acts for the business.
 */
export type RepresentativeCapacity = typeof RepresentativeCapacity[keyof typeof RepresentativeCapacity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RepresentativeCapacity = {
  DIRECTOR: 'DIRECTOR',
  MEMBER: 'MEMBER',
  TRUSTEE: 'TRUSTEE',
  PARTNER: 'PARTNER',
  EMPLOYEE: 'EMPLOYEE',
  ATTORNEY: 'ATTORNEY',
  AGENT: 'AGENT',
  OTHER: 'OTHER',
} as const;
